export default __webpack_public_path__ + "static/media/STL_Investors_Meet_19022026.890e7629.pdf";